module.exports = __webpack_public_path__ + "img/error_500.18d6efa4.svg";